import styled from 'styled-components'

export const Field = styled.input`
  height: 30px;
  border: none;
  border-bottom: ${({ theme }) => `3px solid ${theme.colors.blue}`};
  box-sizing: border-box;

  &:disabled {
    background-color: ${({ theme }) => theme.colors.white};
  }
`
